@if (isOpen) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-base-content/30 backdrop-blur-sm p-4 overflow-y-auto"
    (keydown.escape)="close()"
    tabindex="0"
  >
    <div [class]="'card bg-base-100 shadow-xl w-11/12 max-h-full flex flex-col ' + getWidthStyleString()">
      <div class="card-body overflow-y-auto">
        <h2 class="card-title text-xl font-bold shrink-0">{{ title }}</h2>
        <div class="overflow-y-auto">
          <ng-content/>
        </div>
        <div class="card-actions justify-end mt-4 shrink-0">
          @if (cancelText) {
            <button
              (click)="cancel()"
              class="btn btn-outline"
            >
              {{ cancelText }}
            </button>
          }
          @if (confirmText) {
            <button
              (click)="confirm()"
              class="btn btn-primary"
            >
              {{ confirmText }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>
}
